import React, {useContext, useState} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import FormGroup from '@material-ui/core/FormGroup'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';

import _firebaseContext from '../../../contexts/firebaseContext'
import _appContext from '../../../contexts/appContext'

import UserDeleteAlertDialog from '../../AlertDialog'
import UserSettingDialog from '../UserSettingsDialog'
import AddUserDialog from '../AddUserDialog'
import Options from '../../Options'

export default function UsersList({type, searchRequest, searchRequestHandler, usersLimitToLoad = 20}) {
    const [alertDialogState, setAlertDialogState] = useState(false)
    const [userSettingDialogState, setUserSettingDialogState] = useState(false)
    const [addUserDialogState, setAddUserDialogState] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [onlyActive, setOnlyActive] = useState(false)
    const [roleFilter, setRoleFilter] = useState('all')

    const classes = useStyles()
    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)
    const isLoading = firebaseContext.data.fetchingState[type];

    const handleChangeOnlyActiveCheckbox = event => {
        setOnlyActive(event.target.checked)
    }

    const closeAlertDialog = status => {
        setAlertDialogState(false)

        if (status) {
            handleDeleteBtn(selectedUser)
        }

        setSelectedUser(null)
    }
    const closeUserSettingsDialog = () => {
        setUserSettingDialogState(false)
        setSelectedUser(null)
    }
    const openUserSettingsDialog = user => {
        setSelectedUser(user)
        setUserSettingDialogState(true)
    }
    const openAlertDialog = user => {
        setSelectedUser(user)
        setAlertDialogState(true)
    }
    const refreshUserRepresent = async () => {
        const result = await firebaseContext.updateAllUserRepresent()
        appContext.snackbar.showSnackbarMsg('Представления обновлены')
    }

    const handleRestoreUser = async user => {
        const result = await firebaseContext.restoreUser(user)

        appContext.snackbar.showSnackbarMsg(result.message)
    }

    const handleDeleteBtn = async user => {
        const result = await firebaseContext.disableUser(user)

        appContext.snackbar.showSnackbarMsg(result.message)
    }
    const openAddUserDialog = event => {
        setAddUserDialogState(true)
    }
    const closeAddUserDialog = event => {
        setAddUserDialogState(false)
    }

    const getUserList = () => {
        let userList = firebaseContext.data[type] || []

        if (onlyActive) userList = userList.filter(user => !user.data.hasOwnProperty("isActive") || user.data.isActive)

        if (roleFilter !== 'all')
            userList = userList.filter(user => user.data.role === roleFilter)

        if (searchRequest.length !== 0 && type === 'admins') {
            userList = userList.filter(user => {
                const encapsulated = searchRequest.replace(
                    /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                    ''
                )
                return encapsulated
                    .toLowerCase()
                    .split(/\s+/g)
                    .some(part => {
                        const regex = new RegExp(part, 'g')
                        return (
                            regex.test(user.data.displayName.toLowerCase()) ||
                            regex.test(user.data.phone.toLowerCase()) ||
                            regex.test(user.data.email.toLowerCase())
                        )
                    })
            })
        }

        return userList
    }

    const cancelSearchHandler = () => {
        if (!searchRequest) {
            return;
        }

        searchRequestHandler('');

        if (type === 'users') {
            firebaseContext.getInitialUsersList(usersLimitToLoad);
        }
    }

    const searchUsersHandler = () => {
        if (!searchRequest) {
            return firebaseContext.getInitialUsersList(usersLimitToLoad);
        }

        return firebaseContext.searchInitialUsers(usersLimitToLoad, searchRequest);
    }

    return (
        <>
            <Typography
                variant="h4"
                component="h1"
                className={classes.listTitle}
            >
                Список пользователей
            </Typography>
            <Button
                variant="contained"
                color="default"
                className={classes.addbtn}
                onClick={openAddUserDialog}
            >
                Добавить пользователя
            </Button>
            <Button
                variant="contained"
                color="default"
                className={classes.addbtn}
                onClick={refreshUserRepresent}
            >
                Обновить представления пользователей
            </Button>
            <FormGroup row className={classes.formGroup}>
                <div className={classes.searchBlock}>
                    <IconButton
                        size='small'
                        color='inherit'
                        className={classes.closeIcon}
                        onClick={cancelSearchHandler}
                    >
                        <CloseIcon fontSize='small'/>
                    </IconButton>
                    <TextField
                        label='Поиск'
                        value={searchRequest}
                        onChange={event => searchRequestHandler(event.target.value.toLowerCase())}
                        className={classes.field}
                    />
                    {
                        type === 'users' &&
                        <IconButton
                            size='small'
                            color='inherit'
                            className={classes.searchIcon}
                            onClick={searchUsersHandler}
                        >
                            <SearchIcon fontSize='small'/>
                        </IconButton>
                    }
                </div>
                <div className={classes.onlyActiveBlock}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={onlyActive}
                                onChange={handleChangeOnlyActiveCheckbox}
                                value='onlyActive'
                            />
                        }
                        label='Только активные'
                    />
                </div>
            </FormGroup>
            {
                !isLoading &&
                <List className={classes.root}>
                    {firebaseContext.data[type].length === 0 ? (
                        <Typography variant="body1">
                            В системе пока нет пользователей
                        </Typography>
                    ) : (
                        getUserList().map((user, i) => (
                            <ListItem
                                key={user.id}
                                disabled={user.data.isActive === false}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        src={user.data.photoURL || user.data.avatar}
                                    />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={`${user.data.name || ''} ${user.data
                                        .surname || ''} ${
                                        user.data.isActive === false
                                            ? '(не активен)'
                                            : ''
                                    }`}
                                    secondary={
                                        <>
                                            <Typography
                                                component={'span'}
                                                variant={'body2'}
                                                className={classes.block}
                                            >
                                                {user.data.role || 'user'}
                                            </Typography>
                                            <Typography
                                                component={'span'}
                                                variant={'body2'}
                                                className={classes.block}
                                            >
                                                {user.data.email || 'почта не указана'}
                                            </Typography>
                                            <Typography
                                                component={'span'}
                                                variant={'body2'}
                                                className={classes.block}
                                            >
                                                {user.data.phone || 'номер не указан'}
                                            </Typography>
                                            <Typography
                                                component={'span'}
                                                variant={'body2'}
                                                className={classes.block}
                                            >
                                                Подписка: {user.data.subscriptions?.subscription || 'подписка не указана'}
                                            </Typography>
                                        </>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    {user.data.isActive === false ? (
                                        <>
                                            <Button
                                                onClick={ev =>
                                                    handleRestoreUser(user)
                                                }
                                            >
                                                Восстановить
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Options
                                                obj={user}
                                                addAction={null}
                                                editAction={openUserSettingsDialog}
                                                deleteAction={openAlertDialog}
                                            />
                                        </>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))
                    )}
                </List>
            }
            <UserDeleteAlertDialog
                open={alertDialogState}
                handleClose={closeAlertDialog}
                title="Отключение пользователя!"
                text="Вы уверены, что хотите деактивировать пользователя?"
            />
            <AddUserDialog
                open={addUserDialogState}
                handleClose={closeAddUserDialog}
            />
            {selectedUser !== null && (
                <UserSettingDialog
                    open={userSettingDialogState}
                    handleClose={closeUserSettingsDialog}
                    user={selectedUser}
                />
            )}
        </>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: 500,
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    listTitle: {
        marginTop: '15px',
        marginBottom: '15px',
    },
    formGroup: {
        marginTop: '15px',
        marginBottom: '15px',
    },
    searchBlock: {
        position: 'relative'
    },
    closeIcon: {
        position: 'absolute',
        bottom: 2,
        left: -3
    },
    searchIcon: {
        position: 'absolute',
        bottom: 2,
        right: 0
    },
    onlyActiveBlock: {
        width: '100%',
        marginTop: 15
    },
    field: {
        marginLeft: '32px',
        marginRight: '32px',
    },
    block: {
        display: 'block',
    },
}))
